import React from "react";
import BootstrapTable from "react-bootstrap-table-next";

import user from "assets/img/user.svg";

import { Cut } from "components/Cut";

import "./movingTable.scss";
import { CheckCircle } from "react-feather";
import { dateFormat } from "utils/format";

export const MovingTable = ({ moving, rowEvents }) => {
  const tableColumns = [
    {
      dataField: "number",
      text: "№",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "warehouseOut",
      text: "Склад отправитель",
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    {
      dataField: "warehouseIn",
      text: "Склад получатель",
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    {
      dataField: "carriedOut",
      text: "Пров-но",
      formatter: (cell) =>
        cell ? <CheckCircle color="green" size={17} /> : "",
      headerStyle: () => {
        return { width: "3%" };
      },
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "date",
      text: "Дата",
      formatter: (cell) => dateFormat(cell),
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    {
      dataField: "admin",
      text: "Создал",
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cell, row) => (
        <Cut>
          <span className="user-cell">
            <img src={user} alt="user" />
            {cell}
          </span>
        </Cut>
      ),
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: () => {
        return { width: "4%" };
      },
      headerClasses: () => "right",
      classes: () => "right bold",
    },
    {
      dataField: "comment",
      text: "Комментарий",
      headerStyle: () => {
        return { width: "25%" };
      },
      formatter: (cell, row) => <Cut>{cell}</Cut>,
    },
  ];

  return (
    <>
      <BootstrapTable
        keyField="id"
        data={moving}
        columns={tableColumns}
        bootstrap4
        bordered={false}
        hover={true}
        classes="pointer"
        rowEvents={rowEvents}
      />
    </>
  );
};
